module.exports = __webpack_public_path__ + "static/img/07.9089009.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school/07.png
// module id = DzlN
// module chunks = 1